import {
  WORKOUTS_LIST_REQUEST,
  WORKOUTS_LIST_SUCCESS,
  WORKOUTS_LIST_FAIL,
} from '../constants/workoutsConstants'

const divisions = [
  {
    id: '1',
    title: 'Rx\'d Male',
    description: 'Rx\'d group for all males who will complete an Rx’d version of the set workout.',
    workouts: [
      {
        id: 'w1',
        title: 'PRVN Challenges: "Wedgewood"',
        workoutRows: [
          '3 rounds for time of:',
          '33 Toes-to-bars',
          '22 Thrusters, 105 lbs',
          '5 Rope Climbs, 15 ft',
          '',
          'Time cap: 16 mins'
        ],
        scoreType: 'For Time',
        description: 'This workout begins with the athlete standing under their Pull-up bar. After the call of “3,2,1… go,” the athlete will perform 33 Toes-to-bar, then 22 Thrusters followed by 5 Rope Climbs. Next, the athlete will return back to the Pull-up bar to begin their second round of Toes-to-bar then move forward to the Thrusters and again move back to the Rope Climbs. After they have completed their second round, they will move back to the Toes-to-bar and begin working through their final round. Receiving any assistance moving the barbell is not permitted unless safety is an immediate concern.',
        instructions: 'Athletes will record the time taken to complete the workout in it\'s entirety. The tiebreaker for this challenge is the time taken to complete the first full round of Toes-to-bars, Thrusters and Rope Climbs.',
        equipment: [
          '45/35 lb Barbell (20/15 kg)',
          'Standard size bumper plates or weight plates or correct weight and clearly marked',
          'Collars',
          'Pull-Up Rig',
          'Climbing Rope',
          'Visible clock or timer in frame',
          'A safe, unobstructed area to perform the workout',
          'Chalk, weight belts, knee/elbow sleeves, wrist wraps and any style of shoe are permitted but not required.'
        ],
        movementStandards: [{
         title: 'Thrusters',
         instructions: [
          'Each set of Thrusters begins with the barbell on the ground',
          'The crease of the athlete’s hip must clearly pass below the top of the athlete’s knees in the bottom position.',
          'A full squat clean into the thruster is allowed when the bar is taken from the floor.',
          'The rep must be completed in one fluid motion from the bottom of the squat. A front squat followed by a jerk is not allowed',
          'If the barbell is dropped from overhead, it must settle on the ground before the athlete picks it up for the next repetition',
          'Athletes may NOT receive assistance moving or resetting their barbell.',
         ],
         instructionsNested: [
          'The athletes hips, knees and arms are fully extended; and',
          'The bar is directly over, or slightly behind, the middle of their body.'
         ],
         gif: '-'
        }, {
          title: 'Rope Climbs',
          instructions: [
           'Each rep starts with both feet on the ground',
           'The athlete may jump into the rope climb',
           'Any style of climbing is permitted',
           'The rep is credited when one hand clearly touches above the designated mark. ',
           'Athletes may choose to touch a fixed object, such as a beam or the ceiling, so long as the object is at least 15ft (4.57m) for Rx & 12ft for Intermediate (3.66m)',
           'There is no requirement during the descent of the climb',
          ],
          gif: '-'
        }, {
          title: 'Toes To Bar',
          instructions: [
           'Begin by hanging from the Pull-up bar with arms extended',
           'Heels must be brought back behind the bar',
           'Overhead, Underhand or mixed grip is permitted',
           'The rep is credited when both feet come in contact with the bar at the same time, between the hands.',
           'Any part of the feet may make contact with the bar',
          ],
          gif: '-'
        }],
        videoSubmissionGuidelines: 'The barbell & plates should be filmed in a way that allows the loads to be clearly identified. Videos need to be uncut & unedited in order to accurately display the performance. Videos shot with a fish-eye lens or similar lens may be rejected, we recommend not using such lenses. The clock or timer must be visible during the entire workout. Phone timers, apps and stopwatches are acceptable as long as they are in frame and clearly visible the entire time. Ensure the athlete has ample space to safely perform all aspects of the workout and all potential obstructions have been removed. At the start of the video, the athlete should be in frame, state their name and the workout they are performing. Next, the barbell & plates should be filmed in a way that allows the loads to be clearly identified. Next, the Pull-up Bar location should be filmed and finally the climbing rope should be filmed and measured to the set height standard for their division. Keep in mind everything needs to be filmed in one continuous unedited video.',
        pdfLinks: [{
          title: 'Official Rules, Standards & Submission Guidelines PDF',
          link: 'https://s3.amazonaws.com/media.btwb.co/Competitions/PRVN/prvn-challenges-wedgewood/wedgewood-rules.pdf'
        }],
        movementGifs: [
          '-'
        ],
        movementVideo: 'B0vKD1WZBYs'
      }
    ]
  },{
    id: '2',
    title: 'Rx\'d Female',
    description: 'Rx\'d group for all females who will complete an Rx’d version of the set workout.',
    workouts: [
      {
        id: 'w1',
        title: 'PRVN Challenges: "Wedgewood"',
        workoutRows: [
          '3 rounds for time of:',
          '33 Toes-to-bars',
          '22 Thrusters, 75 lbs',
          '5 Rope Climbs, 15 ft',
          '',
          'Time cap: 16 mins'
        ],
        scoreType: 'For Time',
        description: 'This workout begins with the athlete standing under their Pull-up bar. After the call of “3,2,1… go,” the athlete will perform 33 Toes-to-bar, then 22 Thrusters followed by 5 Rope Climbs. Next, the athlete will return back to the Pull-up bar to begin their second round of Toes-to-bar then move forward to the Thrusters and again move back to the Rope Climbs. After they have completed their second round, they will move back to the Toes-to-bar and begin working through their final round. Receiving any assistance moving the barbell is not permitted unless safety is an immediate concern.',
        instructions: 'Athletes will record the time taken to complete the workout in it\'s entirety. The tiebreaker for this challenge is the time taken to complete the first full round of Toes-to-bars, Thrusters and Rope Climbs.',
        equipment: [
          '45/35 lb Barbell (20/15 kg)',
          'Standard size bumper plates or weight plates or correct weight and clearly marked',
          'Collars',
          'Pull-Up Rig',
          'Climbing Rope',
          'Visible clock or timer in frame',
          'A safe, unobstructed area to perform the workout',
          'Chalk, weight belts, knee/elbow sleeves, wrist wraps and any style of shoe are permitted but not required.'
        ],
        movementStandards: [{
         title: 'Thrusters',
         instructions: [
          'Each set of Thrusters begins with the barbell on the ground',
          'The crease of the athlete’s hip must clearly pass below the top of the athlete’s knees in the bottom position.',
          'A full squat clean into the thruster is allowed when the bar is taken from the floor.',
          'The rep must be completed in one fluid motion from the bottom of the squat. A front squat followed by a jerk is not allowed',
          'If the barbell is dropped from overhead, it must settle on the ground before the athlete picks it up for the next repetition',
          'Athletes may NOT receive assistance moving or resetting their barbell.',
         ],
         instructionsNested: [
          'The athletes hips, knees and arms are fully extended; and',
          'The bar is directly over, or slightly behind, the middle of their body.'
         ],
         gif: '-'
        }, {
          title: 'Rope Climbs',
          instructions: [
           'Each rep starts with both feet on the ground',
           'The athlete may jump into the rope climb',
           'Any style of climbing is permitted',
           'The rep is credited when one hand clearly touches above the designated mark. ',
           'Athletes may choose to touch a fixed object, such as a beam or the ceiling, so long as the object is at least 15ft (4.57m) for Rx & 12ft for Intermediate (3.66m)',
           'There is no requirement during the descent of the climb',
          ],
          gif: '-'
        }, {
          title: 'Toes To Bar',
          instructions: [
           'Begin by hanging from the Pull-up bar with arms extended',
           'Heels must be brought back behind the bar',
           'Overhead, Underhand or mixed grip is permitted',
           'The rep is credited when both feet come in contact with the bar at the same time, between the hands.',
           'Any part of the feet may make contact with the bar',
          ],
          gif: '-'
        }],
        videoSubmissionGuidelines: 'The barbell & plates should be filmed in a way that allows the loads to be clearly identified. Videos need to be uncut & unedited in order to accurately display the performance. Videos shot with a fish-eye lens or similar lens may be rejected, we recommend not using such lenses. The clock or timer must be visible during the entire workout. Phone timers, apps and stopwatches are acceptable as long as they are in frame and clearly visible the entire time. Ensure the athlete has ample space to safely perform all aspects of the workout and all potential obstructions have been removed. At the start of the video, the athlete should be in frame, state their name and the workout they are performing. Next, the barbell & plates should be filmed in a way that allows the loads to be clearly identified. Next, the Pull-up Bar location should be filmed and finally the climbing rope should be filmed and measured to the set height standard for their division. Keep in mind everything needs to be filmed in one continuous unedited video.',
        pdfLinks: [{
          title: 'Official Rules, Standards & Submission Guidelines PDF',
          link: 'https://s3.amazonaws.com/media.btwb.co/Competitions/PRVN/prvn-challenges-wedgewood/wedgewood-rules.pdf'
        }],
        movementGifs: [
          '-'
        ],
        movementVideo: 'B0vKD1WZBYs'
      }
    ]
  },{
    id: '3',
    title: 'Intermediate Male',
    description: 'Rx\'d group for all males who will complete an intermediate version of the set workout.',
    workouts: [
      {
        id: 'w1',
        title: 'PRVN Challenges: "Wedgewood"',
        workoutRows: [
          '3 rounds for time of:',
          '33 Toes-to-bars',
          '22 Thrusters, 95 lbs',
          '5 Rope Climbs, 12 ft',
          '',
          'Time cap: 16 mins'
        ],
        scoreType: 'For Time',
        description: 'This workout begins with the athlete standing under their Pull-up bar. After the call of “3,2,1… go,” the athlete will perform 33 Toes-to-bar, then 22 Thrusters followed by 5 Rope Climbs. Next, the athlete will return back to the Pull-up bar to begin their second round of Toes-to-bar then move forward to the Thrusters and again move back to the Rope Climbs. After they have completed their second round, they will move back to the Toes-to-bar and begin working through their final round. Receiving any assistance moving the barbell is not permitted unless safety is an immediate concern.',
        instructions: 'Athletes will record the time taken to complete the workout in it\'s entirety. The tiebreaker for this challenge is the time taken to complete the first full round of Toes-to-bars, Thrusters and Rope Climbs.',
        equipment: [
          '45/35 lb Barbell (20/15 kg)',
          'Standard size bumper plates or weight plates or correct weight and clearly marked',
          'Collars',
          'Pull-Up Rig',
          'Climbing Rope',
          'Visible clock or timer in frame',
          'A safe, unobstructed area to perform the workout',
          'Chalk, weight belts, knee/elbow sleeves, wrist wraps and any style of shoe are permitted but not required.'
        ],
        movementStandards: [{
         title: 'Thrusters',
         instructions: [
          'Each set of Thrusters begins with the barbell on the ground',
          'The crease of the athlete’s hip must clearly pass below the top of the athlete’s knees in the bottom position.',
          'A full squat clean into the thruster is allowed when the bar is taken from the floor.',
          'The rep must be completed in one fluid motion from the bottom of the squat. A front squat followed by a jerk is not allowed',
          'If the barbell is dropped from overhead, it must settle on the ground before the athlete picks it up for the next repetition',
          'Athletes may NOT receive assistance moving or resetting their barbell.',
         ],
         instructionsNested: [
          'The athletes hips, knees and arms are fully extended; and',
          'The bar is directly over, or slightly behind, the middle of their body.'
         ],
         gif: '-'
        }, {
          title: 'Rope Climbs',
          instructions: [
           'Each rep starts with both feet on the ground',
           'The athlete may jump into the rope climb',
           'Any style of climbing is permitted',
           'The rep is credited when one hand clearly touches above the designated mark. ',
           'Athletes may choose to touch a fixed object, such as a beam or the ceiling, so long as the object is at least 15ft (4.57m) for Rx & 12ft for Intermediate (3.66m)',
           'There is no requirement during the descent of the climb',
          ],
          gif: '-'
        }, {
          title: 'Toes To Bar',
          instructions: [
           'Begin by hanging from the Pull-up bar with arms extended',
           'Heels must be brought back behind the bar',
           'Overhead, Underhand or mixed grip is permitted',
           'The rep is credited when both feet come in contact with the bar at the same time, between the hands.',
           'Any part of the feet may make contact with the bar',
          ],
          gif: '-'
        }],
        videoSubmissionGuidelines: 'The barbell & plates should be filmed in a way that allows the loads to be clearly identified. Videos need to be uncut & unedited in order to accurately display the performance. Videos shot with a fish-eye lens or similar lens may be rejected, we recommend not using such lenses. The clock or timer must be visible during the entire workout. Phone timers, apps and stopwatches are acceptable as long as they are in frame and clearly visible the entire time. Ensure the athlete has ample space to safely perform all aspects of the workout and all potential obstructions have been removed. At the start of the video, the athlete should be in frame, state their name and the workout they are performing. Next, the barbell & plates should be filmed in a way that allows the loads to be clearly identified. Next, the Pull-up Bar location should be filmed and finally the climbing rope should be filmed and measured to the set height standard for their division. Keep in mind everything needs to be filmed in one continuous unedited video.',
        pdfLinks: [{
          title: 'Official Rules, Standards & Submission Guidelines PDF',
          link: 'https://s3.amazonaws.com/media.btwb.co/Competitions/PRVN/prvn-challenges-wedgewood/wedgewood-rules.pdf'
        }],
        movementGifs: [
          '-'
        ],
        movementVideo: 'B0vKD1WZBYs'
      }
    ]
  },{
    id: '4',
    title: 'Intermediate Female',
    description: 'Rx\'d group for all females who will complete an intermediate version of the set workout.',
    workouts: [
      {
        id: 'w1',
        title: 'PRVN Challenges: "Wedgewood"',
        workoutRows: [
          '3 rounds for time of:',
          '33 Toes-to-bars',
          '22 Thrusters, 65 lbs',
          '5 Rope Climbs, 12 ft',
          '',
          'Time cap: 16 mins'
        ],
        scoreType: 'For Time',
        description: 'This workout begins with the athlete standing under their Pull-up bar. After the call of “3,2,1… go,” the athlete will perform 33 Toes-to-bar, then 22 Thrusters followed by 5 Rope Climbs. Next, the athlete will return back to the Pull-up bar to begin their second round of Toes-to-bar then move forward to the Thrusters and again move back to the Rope Climbs. After they have completed their second round, they will move back to the Toes-to-bar and begin working through their final round. Receiving any assistance moving the barbell is not permitted unless safety is an immediate concern.',
        instructions: 'Athletes will record the time taken to complete the workout in it\'s entirety. The tiebreaker for this challenge is the time taken to complete the first full round of Toes-to-bars, Thrusters and Rope Climbs.',
        equipment: [
          '45/35 lb Barbell (20/15 kg)',
          'Standard size bumper plates or weight plates or correct weight and clearly marked',
          'Collars',
          'Pull-Up Rig',
          'Climbing Rope',
          'Visible clock or timer in frame',
          'A safe, unobstructed area to perform the workout',
          'Chalk, weight belts, knee/elbow sleeves, wrist wraps and any style of shoe are permitted but not required.'
        ],
        movementStandards: [{
         title: 'Thrusters',
         instructions: [
          'Each set of Thrusters begins with the barbell on the ground',
          'The crease of the athlete’s hip must clearly pass below the top of the athlete’s knees in the bottom position.',
          'A full squat clean into the thruster is allowed when the bar is taken from the floor.',
          'The rep must be completed in one fluid motion from the bottom of the squat. A front squat followed by a jerk is not allowed',
          'If the barbell is dropped from overhead, it must settle on the ground before the athlete picks it up for the next repetition',
          'Athletes may NOT receive assistance moving or resetting their barbell.',
         ],
         instructionsNested: [
          'The athletes hips, knees and arms are fully extended; and',
          'The bar is directly over, or slightly behind, the middle of their body.'
         ],
         gif: '-'
        }, {
          title: 'Rope Climbs',
          instructions: [
           'Each rep starts with both feet on the ground',
           'The athlete may jump into the rope climb',
           'Any style of climbing is permitted',
           'The rep is credited when one hand clearly touches above the designated mark. ',
           'Athletes may choose to touch a fixed object, such as a beam or the ceiling, so long as the object is at least 15ft (4.57m) for Rx & 12ft for Intermediate (3.66m)',
           'There is no requirement during the descent of the climb',
          ],
          gif: '-'
        }, {
          title: 'Toes To Bar',
          instructions: [
           'Begin by hanging from the Pull-up bar with arms extended',
           'Heels must be brought back behind the bar',
           'Overhead, Underhand or mixed grip is permitted',
           'The rep is credited when both feet come in contact with the bar at the same time, between the hands.',
           'Any part of the feet may make contact with the bar',
          ],
          gif: '-'
        }],
        videoSubmissionGuidelines: 'The barbell & plates should be filmed in a way that allows the loads to be clearly identified. Videos need to be uncut & unedited in order to accurately display the performance. Videos shot with a fish-eye lens or similar lens may be rejected, we recommend not using such lenses. The clock or timer must be visible during the entire workout. Phone timers, apps and stopwatches are acceptable as long as they are in frame and clearly visible the entire time. Ensure the athlete has ample space to safely perform all aspects of the workout and all potential obstructions have been removed. At the start of the video, the athlete should be in frame, state their name and the workout they are performing. Next, the barbell & plates should be filmed in a way that allows the loads to be clearly identified. Next, the Pull-up Bar location should be filmed and finally the climbing rope should be filmed and measured to the set height standard for their division. Keep in mind everything needs to be filmed in one continuous unedited video.',
        pdfLinks: [{
          title: 'Official Rules, Standards & Submission Guidelines PDF',
          link: 'https://s3.amazonaws.com/media.btwb.co/Competitions/PRVN/prvn-challenges-wedgewood/wedgewood-rules.pdf'
        }],
        movementGifs: [
          '-'
        ],
        movementVideo: 'B0vKD1WZBYs'
      }
    ]
  }
]

export const listWorkouts = () => async (dispatch) => {
  try {
    dispatch({ type: WORKOUTS_LIST_REQUEST })

    // const { data } = await axios.get('/api/workouts')

    const data = divisions // temporary

    dispatch({ type: WORKOUTS_LIST_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: WORKOUTS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
